<template>
    <div id="app" class="page" v-cloak @modal-open="openModal()">
        <navigation-component></navigation-component>

        <main class="main-content">
            <transition name="page" mode="out-in">
                <keep-alive :key="$route.meta.id">
                    <router-view :key="$route.meta.id"></router-view>
                </keep-alive>
            </transition>
        </main>

        <transition name="fade">
            <div v-if="pageLoading" class="pageLoader">
                <div class="pageLoader__body">
                    <div class="loader">
                        <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                        </svg>
                    </div>
                </div>
            </div>
        </transition>

        <footer-component v-show="!pageLoading"></footer-component>
        <component v-if="modal.component" :open.sync="modal.isOpen" :is="modal.component"></component>
    </div>
</template>
<script>
    import Http from 'axios';
    import NavigationComponent from '#app#/components/common/Navigation.vue'
    import FooterComponent from '#app#/components/common/Footer.vue'
    import ModalComponent from '#app#/components/common/Modal.vue'
    import NotFound from '#app#/components/errors/404.vue'
    import RouterFunctions from '#app#/router/functions.js'

    export default {
        name: 'app',
        data() {
            return {
                modal: {
                    isOpen: false,
                    component: null,
                },
            };
        },

        components: {
            NavigationComponent,
            FooterComponent,
            ModalComponent
        },

        created() {
            this.buildRoutes();

            this.$store.dispatch('loadLanguages');
            this.$store.dispatch('navigation/loadData');
            this.$store.commit('setLocale', this.$helpers.locale());

            this.$root.$on('modal-open', (e) => {
                this.modal.component = e;
                setTimeout(() => this.modal.isOpen = true, 50);
            });
        },

        methods: {
            buildRoutes() {
                // Build rest of page routes after getting info from server
                this.$store.dispatch('loadRoutesData').then(() => {

                    let routes = this.$store.state.routes
                        .filter(uri => window.PRELOADED_PAGE_DATA === null || uri.id !== window.PRELOADED_PAGE_DATA.id)
                        .map((uri) => RouterFunctions.convertUriToRoute(uri));

                    routes = [
                        ...routes, 
                        {
                            path: `/${this.$helpers.locale()}/vehicle/:id`,
                            component: () => System.import('#app#/components/package/RF/Scout24/VehicleDetail.vue' /* webpackChunkName: "Scout24VehicleDetail" */),
                        }, {
                            name: '404',
                            path: '*',
                            component: NotFound
                        }
                    ];

                    this.$router.addRoutes(routes);
                });
            },

            openModal(event) {
                consoloe.log(event);
            },
        },

        computed: {
            pageLoading() {
                return this.$store.state.pageLoading;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .pageLoader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #000;
        z-index: 100;

        &__body {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            text-align: center;
            text-transform: uppercase;
        }
    }
</style>


// WEBPACK FOOTER //
// js/components/App.vue